// contest verification 
export const  VERIFY_CONTEST_REQUEST = 'VERIFY_CONTEST_REQUEST'
export const  VERIFY_CONTEST_SUCCESS = 'VERIFY_CONTEST_SUCCESS'
export const  VERIFY_CONTEST_ERROR = 'VERIFY_CONTEST_ERROR'
export const  VERIFY_CONTEST_FINISH = 'VERIFY_CONTEST_FINISH'

// contest Participant
export const  REGISTER_PARTICIPANT_REQUEST = 'REGISTER_PARTICIPANT_REQUEST'
export const  REGISTER_PARTICIPANT_SUCCESS = 'REGISTER_PARTICIPANT_SUCCESS'
export const  REGISTER_PARTICIPANT_ERROR = 'REGISTER_PARTICIPANT_ERROR'
export const  REGISTER_PARTICIPANT_SET_INIT_MODE = 'REGISTER_PARTICIPANT_SET_INIT_MODE'

// constent popup
export const POPUP_ACTIVE = 'POPUP_ACTIVE'
export const POPUP_DEACTIVE = 'POPUP_DEACTIVE'
export const POPUP_NAME = 'initpopup'


export const HEADERS = {
    ACCEPT : 'accept',
    CONTENT_TYPE : 'content-type',
    AUTHORIZATION :'Authorization',
    PRAGMA :'pragma',
    CACHE_CONTROL :'cache-control',
}

export const CONTENT_TYPE = {
    MULTIPART: 'multipart/form-data',
    JSON: 'application/json',
    URLENCODED: 'application/x-www-form-urlencoded'
}

export const METHOD = {
    GET:'GET',
    POST:'POST',
    PUT:'PUT',
    PATCH:'PATCH',
    DELETE:'DELETE',
}